/* pd-blog-related.js — fylder kortrækken under en artikel.

   Rækken kan ikke bygges i Liquid. På en artikelside er bloggens artikelliste
   skåret ned til den artikel, man står på (blog.articles.size == 1), og det gælder
   også blogs['viden']. Derfor hentes kortene fra en URL uden artikelkontekst:
   /blogs/<blog>?view=pd-kort, som svarer med rå <li>-kort fra samme snippet som
   blogoversigten (templates/blog.pd-kort.liquid).

   Først forsøges emne-URL'en (/tagged/<emne>), så rækken viser noget, der faktisk
   hænger sammen med det, man lige har læst. Rækker det ikke til det aftalte antal,
   fyldes der op med de nyeste fra bloggen.

   Rækken ligger skjult, indtil der er kort at vise. Går hentningen galt, bliver den
   skjult — en tom overskrift uden kort er værre end ingen række. Artiklens egen
   "Læs også"-boks står stadig i teksten og er den, søgemaskiner følger. */

(() => {
  const roots = document.querySelectorAll('[data-pd-related]');
  if (!roots.length || typeof DOMParser === 'undefined') return;

  /* Kortene kommer som en stump HTML uden rod-element. De pakkes i en <ul>, fordi
     <li> uden for en liste bliver smidt væk af HTML-parseren. */
  const parseCards = (html, currentUrl, seen) => {
    const doc = new DOMParser().parseFromString(`<ul>${html}</ul>`, 'text/html');
    const found = [];

    doc.querySelectorAll('.pd-bcard').forEach((card) => {
      const href = card.querySelector('.pd-bcard__link')?.getAttribute('href');
      if (!href || href === currentUrl || seen.has(href)) return;
      seen.add(href);
      found.push(card);
    });

    return found;
  };

  const fill = async (root) => {
    const grid = root.querySelector('[data-pd-related-grid]');
    if (!grid) return;

    const limit = parseInt(root.dataset.limit, 10) || 3;
    const currentUrl = root.dataset.current || '';
    const seen = new Set();
    const picked = [];

    for (const url of [root.dataset.tagUrl, root.dataset.feedUrl]) {
      if (!url || picked.length >= limit) continue;

      try {
        const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) continue;
        picked.push(...parseCards(await response.text(), currentUrl, seen));
      } catch (error) {
        /* Netværksfejl: prøv næste URL, og lad ellers rækken blive skjult. */
      }
    }

    if (!picked.length) return;

    picked.slice(0, limit).forEach((card) => grid.appendChild(card));

    /* To kort i fire kolonner ser forladt ud — samme regel som på blogoversigten. */
    grid.classList.add(grid.children.length <= 2 ? 'pd-bgrid--sparse' : 'pd-bgrid--cols3');
    root.hidden = false;
  };

  roots.forEach(fill);
})();
